import { TrackEventInput } from '@updater/ui-tracker';
import {
  TabLayoutGrid,
  TabLayoutGridProps,
} from 'flows/core/components/tab-layout-grid';
import { CardData } from 'flows/core/types/cards';
import React from 'react';
import { useTracking } from 'react-tracking';

import { SingleCard } from 'flows/core/components/cards/single-card';
import { EssentialsCard } from 'flows/core/components/cards/essentials-card/EssentialsCard';

interface TabLayoutCartLayoutProps extends TabLayoutGridProps {
  data: CardData[] | undefined;
  section?: string;
  isEssentials?: boolean;
}

export const TabLayoutCardLayout: React.FC<TabLayoutCartLayoutProps> = ({
  title,
  gridTemplateColumns,
  data,
  section,
  gridGap,
  isEssentials = false,
}) => {
  const { Track } = useTracking<TrackEventInput<unknown>>({
    details: {
      section,
    },
  });
  if (!Array.isArray(data)) {
    return <div>Incorrect data!</div>;
  }

  const CardComponent = isEssentials ? EssentialsCard : SingleCard;

  return (
    <Track>
      <TabLayoutGrid
        title={title}
        gridTemplateColumns={gridTemplateColumns}
        gridGap={gridGap}
      >
        {data.map((card, index) => {
          return (
            <CardComponent card={card} position={index} key={card.identifier} />
          );
        })}
      </TabLayoutGrid>
    </Track>
  );
};
